var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.5,
    height: 65.5,
    viewBox: "0 0 65.5 65.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feedback_Icon",
    "data-name": "Feedback Icon",
    transform: "translate(-17.842 -18.026)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(18.592 18.776)",
    fill: "#fff",
    stroke: "#cacaca",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M74.86,45.655v22.7H67.491l.914,3.088.019.063L64.9,68.836l-.644-.486H40.915v-22.7H74.86m.077-2.4h-34.1a2.33,2.33,0,0,0-2.328,2.328V68.427a2.33,2.33,0,0,0,2.328,2.328H63.452L72.373,77.5a.191.191,0,0,0,.106.038.174.174,0,0,0,.168-.226L70.709,70.76h4.867a1.687,1.687,0,0,0,1.688-1.688V45.583a2.33,2.33,0,0,0-2.328-2.328h0Z",
    transform: "translate(-7.295 -9.755)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2670",
    "data-name": "Group 2670",
    transform: "translate(42.269 37.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M73.7,70.087H72.16a1.116,1.116,0,0,1-1.145-1.125,6.45,6.45,0,0,0-.731-2.717c-.183-.361-.409-.7-.616-1.048a4.772,4.772,0,0,1-.515-1.217,4.887,4.887,0,0,1,2.034-5.391,4.547,4.547,0,0,1,2.847-.731,4.761,4.761,0,0,1,4.314,3.958,4.833,4.833,0,0,1-.75,3.6,7.3,7.3,0,0,0-1.149,2.866,5.162,5.162,0,0,0-.063.664,1.118,1.118,0,0,1-1.14,1.14H73.694Z",
    transform: "translate(-65.378 -54.562)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M78.634,89.5a1.194,1.194,0,0,1-.673.755.947.947,0,0,1-.361.072c-.75,0-1.5,0-2.256,0A1.114,1.114,0,0,1,74.31,89.5h4.319Z",
    transform: "translate(-68.144 -70.993)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M76.448,83.7H78.3a.335.335,0,0,1,.341.366.345.345,0,0,1-.337.375H74.587a.279.279,0,0,1-.293-.216.569.569,0,0,1,.029-.361.392.392,0,0,1,.289-.159C75.222,83.687,75.837,83.7,76.448,83.7Z",
    transform: "translate(-68.128 -67.979)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M76.448,87.54h1.823a.3.3,0,0,1,.308.188.381.381,0,0,1-.212.543.587.587,0,0,1-.13,0H74.6a.367.367,0,0,1-.337-.529.32.32,0,0,1,.327-.216h1.856Z",
    transform: "translate(-68.104 -69.971)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M76.423,85.63h1.823a.338.338,0,0,1,.37.366.346.346,0,0,1-.366.375H74.6a.346.346,0,0,1-.37-.37.342.342,0,0,1,.366-.37h1.823Z",
    transform: "translate(-68.103 -68.985)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M78.54,53.771a.241.241,0,0,1-.24-.24V51.26a.241.241,0,0,1,.24-.24.238.238,0,0,1,.24.24v2.27A.241.241,0,0,1,78.54,53.771Z",
    transform: "translate(-70.215 -51.02)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M71.226,55.8a.238.238,0,0,1-.207-.12l-1.135-1.962a.239.239,0,0,1,.414-.24l1.135,1.962a.237.237,0,0,1-.087.327A.217.217,0,0,1,71.226,55.8Z",
    transform: "translate(-65.83 -52.235)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M65.913,61.207a.228.228,0,0,1-.12-.034l-1.962-1.135a.239.239,0,1,1,.24-.414l1.962,1.135a.24.24,0,0,1-.12.447Z",
    transform: "translate(-62.643 -55.469)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    d: "M64,68.551H61.73a.241.241,0,0,1-.24-.24.238.238,0,0,1,.24-.24H64a.241.241,0,0,1,.24.24A.238.238,0,0,1,64,68.551Z",
    transform: "translate(-61.49 -59.87)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M84.631,55.8a.228.228,0,0,1-.12-.034.237.237,0,0,1-.087-.327l1.135-1.962a.239.239,0,1,1,.414.24l-1.135,1.962A.238.238,0,0,1,84.631,55.8Z",
    transform: "translate(-73.377 -52.235)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M89.051,61.207a.24.24,0,0,1-.12-.447l1.962-1.135a.239.239,0,1,1,.24.414l-1.962,1.135A.217.217,0,0,1,89.051,61.207Z",
    transform: "translate(-75.671 -55.469)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M92.891,68.551H90.62a.241.241,0,0,1-.24-.24.238.238,0,0,1,.24-.24h2.27a.241.241,0,0,1,.24.24A.238.238,0,0,1,92.891,68.551Z",
    transform: "translate(-76.486 -59.87)",
    fill: "#a5551c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/Feedback.c83d2f56a67fa8e76171f6cff0972f37.svg";
export { ForwardRef as ReactComponent };